// extracted by mini-css-extract-plugin
export default {"commentaryItem":"commentary_list-module__commentaryItem--2tdkm","commentaryPaper":"commentary_list-module__commentaryPaper--MCG5e","pointer":"commentary_list-module__pointer--23jDf"};